import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios";
import { getProject, updateProject } from "./project";
import { updateTask } from "./task";



export async function getTaskSummary({ projectId, taskId, from, to, equipmentQuery }) {
  let url = `${BASE_URL}/api/dashboard?`;
  url += getQueryParamsString({ projectId, taskId, from, to, equipmentQuery });

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function getDashboardSummary({ projectId, taskId, from, to, equipmentQuery, todayDate }) {
  let url = `${BASE_URL}/api/dashboard/summary?`;
  url += getQueryParamsString({ projectId, taskId, from, to, equipmentQuery, todayDate });

  const res = await axiosInstance.get(url)
  return res.data.Data;
}



export async function assignTask({ taskId, userId, equipmentId, projectId }) {
  try {
    if (projectId) {
      const project = await getProject(projectId);
      if (userId) {
        await updateProject({
          ...project,
          projectUsers: [
            {
              isActive: 1,
              user: {
                id: userId
              },
              project: {
                id: project.id
              }
            }
          ]
        })
        await updateTask({
          id: taskId,
          assignee: userId,
        })
      } else {
        await updateProject({
          ...project,
          projectEquipments: [
            {
              isActive: 1,
              equipment: {
                id: equipmentId
              },
              project: {
                id: project.id
              }
            }
          ]
        })
        await updateTask({
          id: taskId,
          equipment: equipmentId,
        })
      }
    }
  } catch (error) {
    console.error(error)
  }
}

